(function () {
  if (window.__ndCollectionImageToggleInit) return;
  window.__ndCollectionImageToggleInit = true;

  var KEY = 'nd:collectionImageView';
  var GROUP = '[data-collection-image-toggle]';
  var RADIO = '[role="radio"]';
  var GRID = '#ProductGridContainer.nd-image-toggle-on';
  var SWAP = 'img[data-onhand-src]';

  function currentView() {
    try {
      return localStorage.getItem(KEY) === 'onhand' ? 'onhand' : 'inbox';
    } catch (e) {
      return 'inbox';
    }
  }

  // Swap an image's displayed source to the given view. No-op if already shown
  // or if that view has no source. Offscreen lazy images keep deferring until
  // near the viewport, so this never forces an eager load.
  function showImage(img, view) {
    var src = img.getAttribute('data-' + view + '-src');
    if (!src || img.getAttribute('src') === src) return;
    var srcset = img.getAttribute('data-' + view + '-srcset');
    img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset);
  }

  // On-hand mode switches the grid to the theme's existing single-column layout
  // (grid--1-col-tablet-down -> 1 product per row on tablet-down); in-box
  // restores the section's configured default. The default is read from the
  // server-rendered data-cols-mobile attribute (NOT memoized from the live DOM)
  // so it survives the inline pre-paint swap and facet AJAX re-renders.
  var TABLET_DOWN_RE = /grid--\d+-col-tablet-down/;

  function applyColumns(view) {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !container.classList.contains('nd-image-toggle-on')) return;
    var ul = document.getElementById('product-grid');
    if (!ul || !ul.classList) return;
    var defaultClass = 'grid--' + (ul.getAttribute('data-cols-mobile') || '2') + '-col-tablet-down';
    var target = view === 'onhand' ? 'grid--1-col-tablet-down' : defaultClass;
    var match = ul.className.match(TABLET_DOWN_RE);
    var current = match ? match[0] : null;
    if (current === target) return;
    if (current) ul.classList.remove(current);
    ul.classList.add(target);
  }

  // Apply the global toggle view to every collection-grid card that has an
  // on-hand image. Records the resting view on each image so hover can restore.
  function applyView(view) {
    applyColumns(view);
    document.querySelectorAll(GRID + ' ' + SWAP).forEach(function (img) {
      img.dataset.rest = view;
      showImage(img, view);
    });
  }

  function syncButtons(view) {
    document.querySelectorAll(GROUP).forEach(function (group) {
      group.querySelectorAll(RADIO).forEach(function (radio) {
        var checked = radio.getAttribute('data-view') === view;
        radio.setAttribute('aria-checked', checked ? 'true' : 'false');
        radio.setAttribute('tabindex', checked ? '0' : '-1');
        radio.classList.toggle('is-active', checked);
      });
    });
  }

  function setView(view) {
    try {
      if (view === 'onhand') localStorage.setItem(KEY, 'onhand');
      else localStorage.removeItem(KEY);
    } catch (e) {}
    applyView(view);
    syncButtons(view);
  }

  function sync() {
    var view = currentView();
    applyView(view);
    syncButtons(view);
  }

  // --- Toggle: click ---
  function radioFrom(e) {
    var el = e.target;
    if (el && el.nodeType !== 1) el = el.parentElement;
    return el ? el.closest(GROUP + ' ' + RADIO) : null;
  }

  document.addEventListener('click', function (e) {
    var radio = radioFrom(e);
    if (!radio) return;
    setView(radio.getAttribute('data-view'));
  });

  // --- Toggle: keyboard (WAI-ARIA radio pattern) ---
  document.addEventListener('keydown', function (e) {
    var radio = radioFrom(e);
    if (!radio) return;
    var radios = Array.prototype.slice.call(radio.closest(GROUP).querySelectorAll(RADIO));
    var i = radios.indexOf(radio);
    var next = i;
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = (i + 1) % radios.length; break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = (i - 1 + radios.length) % radios.length; break;
      case 'Home':
        next = 0; break;
      case 'End':
        next = radios.length - 1; break;
      case ' ':
      case 'Enter':
        next = i; break;
      default:
        return;
    }
    e.preventDefault();
    radios[next].focus();
    setView(radios[next].getAttribute('data-view'));
  });

  // --- Desktop hover preview (lazy): show the alternate image while hovering ---
  // Only on hover-capable devices, so touch/mobile never fetches the 2nd image.
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest('.product-card-rework');
      if (!card) return;
      var img = card.querySelector(SWAP);
      if (!img) return;
      var rest = img.dataset.rest || 'inbox';
      showImage(img, rest === 'onhand' ? 'inbox' : 'onhand');
    });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest('.product-card-rework');
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return; // still inside
      var img = card.querySelector(SWAP);
      if (!img) return;
      showImage(img, img.dataset.rest || 'inbox');
    });
  }

  // --- Re-apply after filter/sort replaces the grid (facets.js swaps innerHTML
  // and fires no event). Watch childList only, so our own src/dataset writes
  // (attribute changes) never re-trigger the observer. ---
  function observeGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      applyView(currentView());
    }).observe(grid, { childList: true });
  }

  // --- Lifecycle ---
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });

  function init() {
    sync();
    observeGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
